var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DialogFormDialog',{ref:"dialog",attrs:{"strings":_vm.strings},on:{"reset":_vm.reset}},[_c(_vm.wizardType,{ref:"wizard",tag:"Wizard",attrs:{"form":_vm.values},on:{"update:form":function($event){_vm.values=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }